import {jsonMember, jsonObject} from "typedjson";


/** Ссылка на связанное мероприятие  */

@jsonObject
export class PitActivityEntityLink {

  @jsonMember({name: "dependentEntityCode", constructor: String, emitDefaultValue: false, isRequired: false })
  private _dependentEntityCode: string;

  @jsonMember({name: "dependentEntityId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _dependentEntityId: number;

  @jsonMember({name: "dependentEntityName", constructor: String, emitDefaultValue: false, isRequired: false })
  private _dependentEntityName: string;

  @jsonMember({name: "dependentEntityTypeId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _dependentEntityTypeId: number;

  @jsonMember({name: "description", constructor: String, emitDefaultValue: false, isRequired: false })
  private _description: string;

  @jsonMember({name: "entityLinkId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _entityLinkId: number;

  @jsonMember({name: "linkTypeId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _linkTypeId: number;


  get dependentEntityCode(): string {
    return this._dependentEntityCode;
  }

  set dependentEntityCode(value: string) {
    this._dependentEntityCode = value;
  }

  get dependentEntityId(): number {
    return this._dependentEntityId;
  }

  set dependentEntityId(value: number) {
    this._dependentEntityId = value;
  }

  get dependentEntityName(): string {
    return this._dependentEntityName;
  }

  set dependentEntityName(value: string) {
    this._dependentEntityName = value;
  }

  get dependentEntityTypeId(): number {
    return this._dependentEntityTypeId;
  }

  set dependentEntityTypeId(value: number) {
    this._dependentEntityTypeId = value;
  }

  get description(): string {
    return this._description;
  }

  set description(value: string) {
    this._description = value;
  }

  get entityLinkId(): number {
    return this._entityLinkId;
  }

  set entityLinkId(value: number) {
    this._entityLinkId = value;
  }

  get linkTypeId(): number {
    return this._linkTypeId;
  }

  set linkTypeId(value: number) {
    this._linkTypeId = value;
  }
}
